import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { useContext, useEffect, useState } from "react";

import { IconButton, Stack, Typography } from "@mui/material";
import { ReactComponent as BurgerIcon } from "../../../Assets/Icons/BurgerIcon.svg";

// import TolotechLogo from "../../../Assets/Images/Tolotech_logo_white_new.png";
import { useTranslation } from "react-i18next";
import TolotechLogoText from "../../../Assets/Images/tolotech_logo_white_new_text.png";
import { ColorScheme } from "../../../Themes/ColorScheme";
import { UserContext } from "../../UserContext";
import { MenuItem } from "./MenuItem";

export const MobileSidebarMenu = () => {
	const { t } = useTranslation();
	const { selectedLocation } = useContext(UserContext);
	const [state, setState] = useState(false);
	const [hideContent, setHideContent] = useState(false);

	const MenuLabels = [
		{ title: t("common.locations"), perm_level: 0, link: "/locations" },
		{
			title: t("common.doors"),
			perm_level: 1,
			link: "/doors",
			isBlocked: hideContent
		},
		{
			title: t("common.charging"),
			perm_level: 7,
			link: "/charging",
			isBlocked: hideContent
		},
		{
			title: t("common.customers"),
			perm_level: 7,
			link: "/customers",
			isBlocked: hideContent
		},
		{
			title: t("common.residents"),
			perm_level: 8,
			link: "/residents",
			isBlocked: hideContent
		},
		{
			title: t("common.support"),
			perm_level: 0,
			link: "/support"
		}
	];

	const perm8 = selectedLocation != null &&
		selectedLocation.location_permissions != null &&
		selectedLocation.location_permissions.some(
			(entry) => entry.permission_id === 8
		);

	const perm7 = selectedLocation != null &&
		selectedLocation.location_permissions != null &&
		selectedLocation.location_permissions.some(
			(entry) => entry.permission_id === 7
		);

	const toggleDrawer = (open) => (event) => {
		if (
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		)
			return;

		setState(open);
	};

	const list = () => (
		<Box
			sx={{
				position: "relative",
				width: "70vw",
				minHeight: "100dvh",
				backgroundColor: ColorScheme.background,
				padding: "20px",
				boxSizing: "border-box"
			}}
			role="presentation"
			onClick={toggleDrawer(false)}
			onKeyDown={toggleDrawer(false)}
		>
			<Stack
				direction="row"
				justifyContent="end"
				alignItems="center"
				spacing={2}
				sx={{ padding: "15px", marginBottom: "30px" }}
			>
				<img src={TolotechLogoText} style={{ maxWidth: "70%" }} />
				<div style={{ flex: 1 }} />
			</Stack>

			{hideContent ? (
				<Box sx={{ border: "1px solid white" }}>
					<Typography
						sx={{
							fontSize: "12px",
							color: ColorScheme.secondary,
							textAlign: "center"
						}}
					>
						{t("location.billing_info_missing")}
					</Typography>
				</Box>
			) : undefined}

			{selectedLocation !== null && selectedLocation.location_permissions != null &&
				selectedLocation.location_permissions !== undefined &&
				MenuLabels.map((menu, index) => {
					if (
						menu.perm_level === 0 ||
						(selectedLocation.location_permissions !== undefined &&
							selectedLocation.location_permissions.find(
								(obj) =>
									menu.perm_level === 0 ||
									obj.permission_id === menu.perm_level
							) !== undefined)
					)
						return (
							<MenuItem key={index} index={index} menu={menu} />
						);
					else return;
				})}

			<Box
				spacing={1}
				alignItems="center"
				sx={{
					position: "absolute",
					bottom: 20,
					left: "20px",
					flexDirection: "row",
					display: "flex",
					alignItems: "flex-start"
				}}
			>
				<img src={TolotechLogoText} style={{ maxWidth: "60px" }} />
				<div style={{ width: "10px" }}></div>
				<Typography
					variant="caption"
					sx={{
						color: ColorScheme.secondary,
						marginTop: "-3px"
					}}
				>
					{" ©" + new Date().getFullYear()}
				</Typography>
			</Box>
		</Box>
	);

	useEffect(() => {
		// check billing info
		if (
			selectedLocation?.billing?.business_id === undefined ||
			selectedLocation?.billing?.customer_name === undefined ||
			selectedLocation?.billing?.invoice_address === undefined ||
			selectedLocation?.billing?.invoice_operator === undefined ||
			selectedLocation?.billing?.contact_name === undefined ||
			selectedLocation?.billing?.contact_email === undefined ||
			selectedLocation?.billing?.business_id === null ||
			selectedLocation?.billing?.customer_name === null ||
			selectedLocation?.billing?.invoice_address === null ||
			selectedLocation?.billing?.invoice_operator === null ||
			selectedLocation?.billing?.contact_name === undefined ||
			selectedLocation?.billing?.contact_email === undefined
		)
			setHideContent(true);
		else setHideContent(false); // corrected
		//
	}, [selectedLocation]);

	return (
		<div>
			<IconButton
				onClick={toggleDrawer(true)}
				sx={{
					position: "relative" /* "fixed" */,
					width: "60px",
					height: "100px"
				}}
			>
				<BurgerIcon stroke={ColorScheme.secondary} />
			</IconButton>

			<Drawer open={state} onClose={toggleDrawer(false)}>
				{list()}
			</Drawer>
		</div>
	);
};
